import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  children?: () => ReactNode
}

const PingSutService = ({ children }: Props) => {
  const url = `${SUT_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      method='get'
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default PingSutService
